import { apiClient } from '@/shared/lib/axios';

export interface TenantCheckResponse {
  success: boolean;
  message?: string;
  data?: {
    exists: boolean;
    tenant: {
      id: number;
      name: string;
      site_type: string;
      status: number;
      is_master: boolean;
    } | null;
  };
}

export type TenantCheckPortal = 'admin' | 'clinic';

export const checkTenantSite = async (
  siteType: string,
  portal: TenantCheckPortal = 'clinic'
): Promise<TenantCheckResponse> => {
  const response = await apiClient.get<TenantCheckResponse>('/tenants/check', {
    params: { site_type: siteType, portal },
  });
  return response.data;
};

export interface TenantSiteTypeItem {
  id: number;
  site_type: string;
  name: string;
}

export interface TenantSiteTypesResponse {
  success: boolean;
  message?: string;
  data?: {
    site_types: TenantSiteTypeItem[];
  };
}

/**
 * Get active site types. When siteType is provided (admin portal), API returns only site types in that family.
 */
export const getTenantSiteTypes = async (siteType?: string): Promise<TenantSiteTypesResponse> => {
  const response = await apiClient.get<TenantSiteTypesResponse>(
    '/tenants/site-types',
    siteType ? { params: { site_type: siteType } } : undefined
  );
  return response.data;
};

export interface TenantConfigColumn {
  enable: boolean;
  checked: boolean;
  show: boolean;
}

export interface TenantInsurerDialogContactConfig {
  phone?: string | null;
  department?: string | null;
}

export interface TenantConfig {
  config_enable_select_pre_address: TenantConfigColumn;
  config_none_disp_delegation_message: TenantConfigColumn;
  config_none_disp_delegation2_message: TenantConfigColumn;
  config_none_disp_delegation3_message: TenantConfigColumn;
  config_enable_checkin?: TenantConfigColumn;
  config_insurer_dialog_contact?: TenantInsurerDialogContactConfig | null;
}

export interface TenantConfigResponse {
  success: boolean;
  message?: string;
  data?: TenantConfig;
}

export const getTenantConfig = async (siteType: string): Promise<TenantConfigResponse> => {
  const response = await apiClient.get<TenantConfigResponse>('/tenants/config', {
    params: { site_type: siteType },
  });
  return response.data;
};
